import axios from "axios";
import {
    URL_BASE
} from "@/configs/constants";

const RESOURCE = 'inventorie';
export default {

    loadInventories(context, params) {
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}`, {
                    params
                })
                .then(response => {
                    context.commit('LOAD_INVENTORIE', response.data)
                    return resolve(response.data)
                }).catch(errors => {
                    return reject(errors)
                })
        })
    },

    loadAmountProducts(context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}inventorie-amount/${id}`)
                .then(response => resolve(response.data))
                .catch((e) => reject(e))
        })
    },

    storeInventorie(context, formData) {
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}${RESOURCE}`, formData)
                .then((r) => resolve(r))
                .catch(errors => reject(errors))
                .finally(() => {})
        })
    },

}